/**
 * メッセージ定数定義
 */
export default class MessageConst {
    // 共通メッセージ
    public static readonly S_CONFIRMATION: string = '{0}を実行します。よろしいですか？';
    public static readonly E_REQUIRED: string = '{0}を入力してください。';
    public static readonly E_MAX: string = '{0}は{1}文字以内で入力してください。';
    public static readonly E_SIZE: string = '{0}は{1}文字で入力してください。';
    public static readonly E_REGEX: string = '{0}は{1}で入力してください。';
    public static readonly E_EMAIL: string = '正しい形式の{0}を入力してください。';
    public static readonly E_CREATE_MAIL: string = '{0}が生成できませんでした。';
    public static readonly E_UNSELECTED: string = '{0}を選択してください。';
    public static readonly E_MIN_MAX: string = '{0}は{1}文字以上、{2}文字以下で入力してください。';
    public static readonly E_PASSWORD_REGEX: string = '有効なパスワード入力してください。';
    public static readonly E_PASSWORD_NOT_MATCH: string = 'パスワードが一致していません。';
    public static readonly E_SYSTEM_ERROR: string = 'システムエラーが発生しました。';
    public static readonly E_NOT_FOUND: string = '{0}が見つかりません。';
    public static readonly E_BECAUSE_OF: string = "{0}のため{1}できません。";
    public static readonly E_DATE_ORDER: string = "開始日付≦終了日付となるよう入力してください。";
    public static readonly E_NUM_ORDER: string = "最小値は最大値以下の数値を入力してください。";
    public static readonly E_INPUT_AT_LEAST_ONE: string = "少なくとも片方は入力してください。";
    public static readonly E_CHECK_AT_LEAST_ONE: string = "少なくとも１つはチェックしてください。";
    public static readonly E_SELECT_ONE: string = "選択してください。";
    public static readonly E_ADDRESS_START_END_ERR: string = '先頭、末尾での{0}の入力は不可です。';
    public static readonly E_ADDRESS_DOMAIN_START_END_ERR: string = 'メールアドレスのドメインにて、先頭、末尾での{0}の入力は不可です。';
    public static readonly E_ADDRESS_PERIOD_ERR: string = '連続での{0}の入力は不可です。';
    public static readonly E_FAILED: string = '{0}に失敗しました。';
}
